<template>
  <MTableCell
    class="m-table-cell__default"
    @click="$emit('click-trigger')"
  >
    <div
      v-if="!inEditMode"
      class="m-table-cell__ellipsis-wrapper"
    >
      {{ value }}
    </div>
    <MExpandingInput
      v-else
      :value="innerValue"
      :input-id="inputId"
      :small="true"
      @input="onInput"
    />
  </MTableCell>
</template>

<script>
  import MExpandingInput from 'components/Inputs/Basic/MExpandingInput';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellExpandingInput',
    components: {MTableCell, MExpandingInput},
    props: {
      index: {
        type: [Number, String],
        default: ''
      },
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      inEditMode: {
        type: Boolean,
        default: false
      },
      small: Boolean,
      large: Boolean
    },
    data () {
      return {
        innerValue: ''
      };
    },
    computed: {
      value () {
        return this.tableRow[this.itemKey];
      },
      inputId () {
        return `${this.tableRow.id}_m-table-cell-expanding-input`;
      }
    },
    watch: {
      value: {
        handler () {
          this.innerValue = this.value;
        },
        immediate: true
      }
    },
    methods: {
      onInput (value) {
        this.innerValue = value;
        this.$emit('input', value);
      }
    }
  };
</script>
